/**
 * Project Constants
 * Centralized constants used across the application
 */

// Bangalore's projectId — the original single-tenant scope. Kept as the
// fallback for the multi-city model (a city == a projectId).
export const FIXED_PROJECT_ID = 'sumadhura_edition';

/**
 * The currently-selected city (projectId). Persisted to localStorage by
 * CityContext; components call this instead of hardcoding a projectId so all
 * data is scoped to the active city. Switching cities reloads the app
 * (see CityContext.setCurrentCity), so reading at call-time is sufficient and
 * no prop-drilling/effect-dependency wiring is required.
 *
 * Falls back to Bangalore when nothing is selected yet (e.g. first paint
 * before CityContext initializes).
 */
export function getActiveProjectId() {
  try {
    return localStorage.getItem('currentCity') || FIXED_PROJECT_ID;
  } catch {
    return FIXED_PROJECT_ID;
  }
}
